const STORE_V1 = '/api/store/v1';

export const ENDPOINTS = {
  TENANT_RESOLVE: `${STORE_V1}/tenant/resolve`,
  STOREFRONT_THEME: `${STORE_V1}/storefront/theme`,
  STOREFRONT_LAYOUT: `${STORE_V1}/storefront/layout`,
  STOREFRONT_NAVIGATION: `${STORE_V1}/storefront/navigation`,
  STOREFRONT_FEATURES: `${STORE_V1}/storefront/features`,
  STOREFRONT_AUTH: `${STORE_V1}/storefront/auth`,
  STOREFRONT_PAGE: (slug: string) => `${STORE_V1}/storefront/pages/${encodeURIComponent(slug)}`,
  STOREFRONT_CONTACT: `${STORE_V1}/contact`,
  STOREFRONT_DOWNLOAD: (kind: string) =>
    `${STORE_V1}/storefront/downloads/${encodeURIComponent(kind)}`,
  CATEGORIES: `${STORE_V1}/catalog/categories`,
  CATEGORY_MENU: `${STORE_V1}/catalog/category-menu`,
  CATALOG_TAXONOMY: `${STORE_V1}/catalog/taxonomy`,
  CATEGORY_BY_SLUG: (slug: string) => `${STORE_V1}/catalog/categories/${encodeURIComponent(slug)}`,
  PRODUCTS: `${STORE_V1}/products`,
  PRODUCT_BY_SLUG: (slug: string) => `${STORE_V1}/products/${encodeURIComponent(slug)}`,
  PRODUCT_RELATED: (id: string) => `${STORE_V1}/products/${encodeURIComponent(id)}/related`,
  BRANDS: `${STORE_V1}/brands`,
  BRAND_BY_SLUG: (slug: string) => `${STORE_V1}/brands/${encodeURIComponent(slug)}`,
  PROMOTIONS: `${STORE_V1}/promotions`,
  NEWS: `${STORE_V1}/news`,
  BEST_SELLERS: `${STORE_V1}/best-sellers`,
  SEARCH: `${STORE_V1}/search`,
  AUTH_REGISTER: `${STORE_V1}/auth/register`,
  AUTH_LOGIN: `${STORE_V1}/auth/login`,
  AUTH_REFRESH: `${STORE_V1}/auth/refresh`,
  AUTH_FORGOT: `${STORE_V1}/auth/forgot-password`,
  AUTH_RESET: `${STORE_V1}/auth/reset-password`,
  AUTH_ACTIVATE: `${STORE_V1}/auth/activate`,
  AUTH_B2B_REQUEST: `${STORE_V1}/auth/b2b-access-request`,
  AUTH_B2B_REQUEST_STATUS: `${STORE_V1}/auth/b2b-access-request/status`,
  AUTH_LOGOUT: `${STORE_V1}/auth/logout`,
  ACCOUNT_PROFILE: `${STORE_V1}/account/profile`,
  ACCOUNT_ADDRESSES: `${STORE_V1}/account/addresses`,
  ACCOUNT_ADDRESS: (id: string) => `${STORE_V1}/account/addresses/${encodeURIComponent(id)}`,
  ACCOUNT_LOCALITIES: `${STORE_V1}/account/localities`,
  ACCOUNT_ORDERS: `${STORE_V1}/account/orders`,
  ACCOUNT_ORDER_TRACKING: (id: string) => `${STORE_V1}/account/orders/${encodeURIComponent(id)}/tracking`,
  ACCOUNT_ORDER_RESEND_EMAIL: (id: string) => `${STORE_V1}/account/orders/${encodeURIComponent(id)}/resend-email`,
  ACCOUNT_CURRENT_ACCOUNT: `${STORE_V1}/account/current-account`,
  ACCOUNT_CURRENT_ACCOUNT_BALANCE: `${STORE_V1}/account/current-account/balance`,
  ACCOUNT_PAYMENT_NOTICES: `${STORE_V1}/account/payment-notices`,
  ACCOUNT_PAYMENT_NOTICE_FILE: (id: number | string) =>
    `${STORE_V1}/account/payment-notices/${encodeURIComponent(String(id))}/file`,
  ACCOUNT_FAVORITES: `${STORE_V1}/account/favorites`,
  ACCOUNT_FAVORITE: (productId: string) => `${STORE_V1}/account/favorites/${encodeURIComponent(productId)}`,
  ACCOUNT_HISTORY: `${STORE_V1}/account/history`,
  CART: `${STORE_V1}/cart`,
  CART_ITEMS: `${STORE_V1}/cart/items`,
  CART_ITEM: (id: string | number) => `${STORE_V1}/cart/items/${encodeURIComponent(String(id))}`,
  CARTS: `${STORE_V1}/carts`,
  CART_BY_ID: (id: string | number) => `${STORE_V1}/carts/${encodeURIComponent(String(id))}`,
  CART_ACTIVATE: (id: string | number) => `${STORE_V1}/carts/${encodeURIComponent(String(id))}/activate`,
  CART_CLONE: (id: string | number) => `${STORE_V1}/carts/${encodeURIComponent(String(id))}/clone`,
  CHECKOUT: `${STORE_V1}/checkout`,
  CHECKOUT_SHIPPING: `${STORE_V1}/checkout/shipping-options`,
  CATALOG_CONFIG: `${STORE_V1}/catalog/config`,
  CATALOG_ATTRIBUTES: `${STORE_V1}/catalog/attributes`,
  ADMIN_AUTH_LOGIN: `${STORE_V1}/admin/auth/login`,
  ADMIN_AUTH_EXCHANGE: `${STORE_V1}/admin/auth/exchange`,
  ADMIN_DASHBOARD: `${STORE_V1}/admin/dashboard`,
  ADMIN_OPERATION_COUNTS: `${STORE_V1}/admin/operation-counts`,
  ADMIN_ABANDONED_CARTS: `${STORE_V1}/admin/abandoned-carts`,
  ADMIN_ABANDONED_CARTS_SETTINGS: `${STORE_V1}/admin/abandoned-carts/settings`,
  ADMIN_ABANDONED_CART: (id: number) => `${STORE_V1}/admin/abandoned-carts/${id}`,
  ADMIN_ABANDONED_CART_FOLLOW_UP: (id: number) => `${STORE_V1}/admin/abandoned-carts/${id}/follow-up`,
  ADMIN_ACCESS_REQUESTS: `${STORE_V1}/admin/access-requests`,
  ADMIN_ACCESS_REQUEST_CUSTOMERS: `${STORE_V1}/admin/access-requests/customers`,
  ADMIN_ACCESS_REQUEST_APPROVE: (id: number) => `${STORE_V1}/admin/access-requests/${id}/approve`,
  ADMIN_ACCESS_REQUEST_RESEND: (id: number) => `${STORE_V1}/admin/access-requests/${id}/resend-invite`,
  ADMIN_ACCESS_REQUEST_REJECT: (id: number) => `${STORE_V1}/admin/access-requests/${id}/reject`,
  ADMIN_STOREFRONT_THEME: `${STORE_V1}/admin/storefront/theme`,
  ADMIN_STOREFRONT_LAYOUT: `${STORE_V1}/admin/storefront/layout`,
  ADMIN_STOREFRONT_NAVIGATION: `${STORE_V1}/admin/storefront/navigation`,
  ADMIN_STOREFRONT_FEATURES: `${STORE_V1}/admin/storefront/features`,
  ADMIN_STOREFRONT_AUTH: `${STORE_V1}/admin/storefront/auth`,
  ADMIN_STOREFRONT_PAGES: `${STORE_V1}/admin/storefront/pages`,
  ADMIN_STOREFRONT_ASSETS: `${STORE_V1}/admin/storefront/assets`,
  ADMIN_STOREFRONT_AUDIENCE_OPTIONS: `${STORE_V1}/admin/storefront/audience-options`,
  ADMIN_CATALOG_SETTINGS: `${STORE_V1}/admin/catalog/settings`,
  ADMIN_CATALOG_ATTRIBUTES: `${STORE_V1}/admin/catalog/attributes`,
  ADMIN_CATALOG_ATTRIBUTES_SUGGEST: `${STORE_V1}/admin/catalog/attributes/suggest`,
  ADMIN_CATALOG_RELATED_PRODUCTS: `${STORE_V1}/admin/catalog/related-products`,
  ADMIN_CATALOG_CATEGORY_MENU: `${STORE_V1}/admin/catalog/category-menu`,
  ADMIN_CATALOG_CATEGORY_MENU_EXPORT: `${STORE_V1}/admin/catalog/category-menu-excel`,
  ADMIN_CATALOG_CATEGORY_MENU_IMPORT: `${STORE_V1}/admin/catalog/category-menu-excel`,
  ADMIN_CATALOG_CATEGORY_MENU_PREVIEW: `${STORE_V1}/admin/catalog/category-menu-excel/preview`,
  ADMIN_CATALOG_PRODUCT_RELATIONS: `${STORE_V1}/admin/catalog/product-relations`,
  ADMIN_CATALOG_PRODUCT_RELATIONS_SKU: (sku: string) =>
    `${STORE_V1}/admin/catalog/product-relations/${encodeURIComponent(sku)}`,
  ADMIN_CATALOG_RELATIONS_EXPORT: `${STORE_V1}/admin/catalog/relations-excel`,
  ADMIN_CATALOG_RELATIONS_IMPORT: `${STORE_V1}/admin/catalog/relations-excel`,
  ADMIN_CATALOG_RELATIONS_PREVIEW: `${STORE_V1}/admin/catalog/relations-excel/preview`,
  ADMIN_CATALOG_CARD_DESIGN: `${STORE_V1}/admin/catalog/card-design`,
  ADMIN_CATALOG_CARD_DESIGN_PRESET: (template: string) =>
    `${STORE_V1}/admin/catalog/card-design/presets/${encodeURIComponent(template)}`,
  ADMIN_CATALOG_PRODUCT_PAGE_DESIGN: `${STORE_V1}/admin/catalog/product-page-design`,
  ADMIN_CATALOG_PRODUCT_PAGE_DESIGN_PRESET: (template: string) =>
    `${STORE_V1}/admin/catalog/product-page-design/presets/${encodeURIComponent(template)}`,
  ADMIN_CATALOG_STORE_PRODUCTS: `${STORE_V1}/admin/catalog/store-products`,
  ADMIN_CATALOG_STORE_PRODUCT: (sku: string) =>
    `${STORE_V1}/admin/catalog/store-products/${encodeURIComponent(sku)}`,
  ADMIN_CATALOG_PRODUCT_SPECS: `${STORE_V1}/admin/catalog/product-specs`,
  ADMIN_CATALOG_PRODUCT_SPECS_EXPORT: `${STORE_V1}/admin/catalog/specs-excel`,
  ADMIN_CATALOG_PRODUCT_SPECS_IMPORT: `${STORE_V1}/admin/catalog/specs-excel`,
  ADMIN_CATALOG_PRODUCT_SPECS_PREVIEW: `${STORE_V1}/admin/catalog/specs-excel/preview`,
  ADMIN_CATALOG_PRODUCT_SPECS_SKU: (sku: string) =>
    `${STORE_V1}/admin/catalog/product-specs/${encodeURIComponent(sku)}`,
  ADMIN_CONFIG_PACK: `${STORE_V1}/admin/config-pack`,
  ADMIN_CONFIG_PACK_PREVIEW: `${STORE_V1}/admin/config-pack/preview`,
} as const;
